module.exports = __webpack_public_path__ + "static/media/caret-up-black.3978c462.svg";